var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"btt",attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer',{on:{"btt":_vm.backToTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }